import React from 'react'
import { Route, Link } from 'react-router-dom'
import styled from 'styled-components'

import { color } from '../globalStyles'

const NavLink = styled.span`
  a {
    padding: .5rem 1rem;
    display: block;
    font-weight: 400;
    font-size: 1.2rem;
    transition: color 0.2s, border-bottom-color 0.2s;
    color: ${props => props.active ? color.primary : 'inherit'};
    text-decoration: none;
    border-bottom: 1px solid;
    border-bottom-color: ${props => props.active ? color.primary : 'transparent'};
    &:hover, &:active, &:focus {
      color: ${props => props.active ? color.primary : 'inherit'};
    }
  }
`

export default ({path, exact, className, ...props}) => (
  <Route path={path} exact={exact} children={({match}) => (
    <NavLink className={className} active={match}>
      <Link to={path}>{props.title}</Link>
    </NavLink>
  )} />
)



// WEBPACK FOOTER //
// ./src/components/NavLink.js